import { render, staticRenderFns } from "./notification-center.component.vue?vue&type=template&id=5fe1e246&"
import script from "./notification-center.component.vue?vue&type=script&lang=tsx&"
export * from "./notification-center.component.vue?vue&type=script&lang=tsx&"
import style0 from "./notification-center.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports